import readServerError from '%app/js/common/services/readServerError';

const SERVER_ERROR_STATUS_FLOOR = 500;

function carriesReadableErrorBody(status) {
    return typeof status === 'number' && status < SERVER_ERROR_STATUS_FLOOR;
}

function readClientErrorEnvelope(error) {
    if (!error || !error.response || !carriesReadableErrorBody(error.response.status)) {
        return null;
    }
    const { status, data } = error.response;

    return { status, ...readServerError(data) };
}

export default readClientErrorEnvelope;
export { carriesReadableErrorBody };
